<template>
  <section class="should-you-call-flop-steps">
    <section>
      <h4>Step {{ 4 + state.players.numPlayers }}: What are the flop cards?</h4>
      <flop-selector
        v-bind:presetCommunityCards="state.presetCommunityCards"
        v-bind:presetHoleCards="state.presetHoleCards"
        v-bind:popoverDirectionClass="'dropdown'"
        v-bind:disabled="!authorized"
        v-on:setIndividualPresetCommunityCard="$emit('setIndividualPresetCommunityCard', $event)"
        v-on:removePresetCommunityCard="$emit('removePresetCommunityCard', $event)"
        v-on:setBoard="$emit('setBoard', $event)"
      />
    </section>
    <section v-if="state.streetToCall === 'flop' && state.presetCommunityCards.flopSet">
      <pot-odds-selector
        v-bind:numOpponents="state.players.numPlayers"
        v-bind:streetToCall="state.streetToCall"
        v-bind:potOdds="state.potOdds"
        v-bind:authorized="authorized"
        v-on:setPotOdds="$emit('setPotOdds', $event)"
      />
      <!-- <betting-criteria-table
        v-if="state.players.numPlayers === 1"
        v-bind:state="state"
        v-bind:breakevenPercentageViaPotOdds="$store.getters['guidedAnalysesCalling/breakevenPercentageViaPotOdds']"
        v-bind:breakevenPercentageViaRealOdds="$store.getters['guidedAnalysesCalling/breakevenPercentageViaRealOdds']"
        v-on:setRealOddsLHS="$emit('setRealOddsLHS', $event)"
        v-on:simulate="$emit('setBettingCriteria')"
      /> -->
    </section>
    <section v-if="state.presetCommunityCards.flopSet">
      <set-range-step
        v-for="(player, playerIndex) in state.players._players"
        v-bind:key="player.key"
        v-bind:textForStep="getTextForPlayerRangeStep(playerIndex)"
        v-bind:player="player"
        v-bind:playerIndex="playerIndex"
        v-bind:playerStateIndex="1"
        v-bind:presetCommunityCards="state.presetCommunityCards"
        v-bind:presetHoleCards="state.presetHoleCards"
        v-bind:textWhenFiveCardHandPercentagesArentUpToDate="textWhenFiveCardHandPercentagesArentUpToDate"
        v-bind:storeModuleName="'guidedAnalysesCalling'"
        v-bind:authorized="authorized"
      >
        <flop-selector
          v-if="state.streetToCall === 'flop'"
          slot="boardCardsSelector"
          class="board-cards-selector"
          v-bind:presetCommunityCards="state.presetCommunityCards"
          v-bind:presetHoleCards="state.presetHoleCards"
          v-bind:popoverDirectionClass="'dropdown'"
          v-bind:disabled="!authorized"
          v-on:setIndividualPresetCommunityCard="$emit('setIndividualPresetCommunityCard', $event)"
          v-on:removePresetCommunityCard="$emit('removePresetCommunityCard', $event)"
          v-on:setBoard="$emit('setBoard', $event)"
        />
        <range-help-section
          slot="rangeHelpSection"
          v-bind:playerStateIndex="1"
          v-bind:streetToCall="state.streetToCall"
        />
      </set-range-step>
    </section>
  </section>
</template>

<script>
import FlopSelector from '@/components/controls/card-selection/flop-selector';
import PotOddsSelector from '@/components/guided-analyses/should-you-call/pot-odds-selector';
import BettingCriteriaTable from '@/components/guided-analyses/should-you-call/conclusions/betting-criteria-table';
import SetRangeStep from '@/components/guided-analyses/set-range-step';
import RangeHelpSection from '@/components/guided-analyses/should-you-call/help/range';

export default {
  name: 'should-you-call-flop-steps',
  components: {
    'flop-selector': FlopSelector,
    'pot-odds-selector': PotOddsSelector,
    'betting-criteria-table': BettingCriteriaTable,
    'set-range-step': SetRangeStep,
    'range-help-section': RangeHelpSection,
  },
  props: [
    'state',
    'textWhenFiveCardHandPercentagesArentUpToDate',
    'authorized',
  ],
  methods: {
    getTextForPlayerRangeStep: function (playerIndex) {
      let numOpponents = this.state.players.numPlayers;

      if (this.state.streetToCall === 'flop' && numOpponents === 1) {
        return `Step ${6 + numOpponents + playerIndex}: What do you think your opponent would bet the flop with?`;
      } else if (this.state.streetToCall === 'flop' && numOpponents > 1) {
        return `Step ${6 + numOpponents + playerIndex}: What do you think opponent #${playerIndex + 1}'s range is after the flop action is finished (eg. heading in to the turn)?`
      } else if (this.state.streetToCall !== 'flop' && numOpponents === 1) {
        return `Step ${5 + numOpponents + playerIndex}: What do you think your opponents range is after the flop action is finished (eg. heading in to the turn)?`;
      } else if (this.state.streetToCall !== 'flop' && numOpponents > 1) {
        return `Step ${5 + numOpponents + playerIndex}: What do you think opponent #${playerIndex + 1}'s range is after the flop action is finished (eg. heading in to the turn)?`
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  .betting-criteria-table {
    margin: 20px 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/guided-analyses/should-you-call/flop-steps.vue